import { Message } from './app-message.model';

export class MessageListResponse {
  totalPosts: number;
  posts: Message[];
}
